import MenuIcon from '@mui/icons-material/Menu';
import { Box, IconButton } from '@mui/material';

type MobileMenuBtnProps = {
  setOpenDrawer: (open: boolean) => void;
};

export const MobileMenuButton = (props: MobileMenuBtnProps) => {
  return (
    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
      <IconButton
        size="large"
        aria-label="open navigation menu"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={() => props.setOpenDrawer(true)}
        color="inherit"
      >
        <MenuIcon />
      </IconButton>
    </Box>
  );
};
